import axios from 'axios'
import baseURL from '@/plugins/http/baseURL'

export default {
  data: function () {
    return {
      actions: false
    }
  },
  props: {
    file: {
      type: Object,
      require: true
    }
  },
  methods: {
    forceFileDownload (response, file) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', file.description.replace(/\s/g, '') + `.${file.files[0].extension}`)
      document.body.appendChild(link)
      link.click()
    },
    downloadFile (file) {
      axios({
        method: 'post',
        url: baseURL + '/v1/dweller/file/download',
        data: {id: file.files[0].id},
        responseType: 'arraybuffer'
      })
      .then(response => {
        this.forceFileDownload(response, file)
      })
      .catch(() => console.log('error occured'))
    },
    viewActions (status) {
      if (status) {
        this.actions = false
      } else {
        this.actions = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/files/index/components/resources/index.js